export type WebSocketManagerOptions = { reconnect: boolean, reconnectInterval: number }

export const initWebSocket = (path: string, options?: WebSocketManagerOptions): WebSocketManager => {
  return new WebSocketManager(path, options)
}
export class WebSocketManager {
  private _ws: WebSocket
  onopen: ((event: Event) => void)[] = []
  onclose: ((event: Event) => void)[] = []
  onerror: ((event: Event) => void)[] = []
  onmessage: ((event: MessageEvent) => void)[] = []
  private _reconnect: boolean
  private _reconnectInterval: number
  private _connected: boolean = false

  constructor(path: string, options: WebSocketManagerOptions = { reconnect: true, reconnectInterval: 1000 }) {
    this._reconnect = options.reconnect
    this._reconnectInterval = options.reconnectInterval
    this._ws = this.init(path)
  }

  init(path: string) {
    this._ws = new WebSocket(/^wss?:\/\//i.test(path) ? path : `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}${path}`)
    this._ws.binaryType = "arraybuffer"

    this._ws.onopen = (event) => {
      this._connected = true
      if (this.onopen) {
        this.onopen.forEach(fn => fn(event))
      }
    }
    this._ws.onclose = (event) => {
      this._connected = false
      if (this.onclose) {
        this.onclose.forEach(fn => fn(event))
      }
      if (this._reconnect) {
        setTimeout(() => {
          this._ws = this.init(path)
          console.info("Reconnecting...")
        }, this._reconnectInterval)
      }
    }
    this._ws.onerror = (event) => {
      if (this.onerror) {
        this.onerror.forEach(fn => fn(event))
      }
    }
    this._ws.onmessage = (event) => {
      if (this.onmessage) {
        this.onmessage.forEach(fn => fn(event))
      }
    }

    return this._ws
  }

  send(data: ArrayBuffer | string) {
    if (this._connected) {
      this._ws.send(data)
    } else {
      const interval = setInterval(() => {
        if (this._connected) {
          clearInterval(interval)
          this._ws.send(data)
        }
      }, 100)
    }
  }
}
